import ClientsHomeCarousel from "./ClientsHomeCarousel"
import "./ClientsHome.css";

function ClientsHome() {
    return (
        <div className="clientshome-container">
           <h1 className="carousel-home-title">عملاءنا</h1>
           <p>في المملكة العربية السعودية</p>
            <div>
                <ClientsHomeCarousel />
            </div>
        </div>
    );
}

export default ClientsHome;
